import { render, staticRenderFns } from "./TokenHistory.vue?vue&type=template&id=3c9ab52a&scoped=true&"
import script from "./TokenHistory.vue?vue&type=script&lang=js&"
export * from "./TokenHistory.vue?vue&type=script&lang=js&"
import style0 from "./TokenHistory.vue?vue&type=style&index=0&id=3c9ab52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ab52a",
  null
  
)

export default component.exports